const GET_REASON_CODE = 'GET_REASON_CODE';
const SET_REASON_CODE = 'SET_REASON_CODE';
const GET_REQUISITION_REASON_CODE = 'GET_REQUISITION_REASON_CODE';
const SET_REQUISITION_REASON_CODE = 'SET_REQUISITION_REASON_CODE';


export {
    GET_REASON_CODE,
    SET_REASON_CODE,
    GET_REQUISITION_REASON_CODE,
    SET_REQUISITION_REASON_CODE
};
